import { connectAuthEmulator, getAuth } from 'firebase/auth';

import {
  client,
  firebaseApp,
  getSubject,
  logout,
  useData,
  useSubject,
} from '@virtual-care/ui';

export const auth = getAuth(firebaseApp);

if (import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST) {
  connectAuthEmulator(
    auth,
    `http://${import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST}`,
    { disableWarnings: true },
  );
}

export async function getIdentity() {
  const subject = await getSubject(auth);
  if (!subject) {
    return null;
  }

  const user = await client
    .request('GET /coordinators/me', {})
    .catch(async (error) => {
      await logout(auth).catch(() => {
        // noop
      });
      console.error(error);
      return null;
    });
  if (!user) {
    await logout(auth);
    return null;
  }
  return { user, subject };
}

export function useUser() {
  const subject = useSubject(auth);
  return useData(
    'GET /coordinators/me',
    {},
    { enabled: !!subject?.uid, staleTime: Infinity },
  );
}
